import React from 'react';
import { ArrowRight, Building2, Handshake, MessageCircle, PieChart, Search, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

const modelIcons = [Building2, Handshake, PieChart, Search];

export function UrbanTransportPartnershipSection({ copy, quoteUrl, onWhatsapp }) {
  return (
    <section id="urban-transport-partnership" className="max-w-6xl mx-auto mb-20 sm:mb-28 scroll-mt-28 min-w-0 overflow-x-hidden">
      <div className="text-center mb-8 sm:mb-10">
        <div className="inline-flex max-w-full min-w-0 flex-wrap items-center justify-center gap-2 rounded-full border border-emerald-500/20 bg-emerald-500/[0.06] px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-emerald-200/90 mb-4">
          <Sparkles className="w-3.5 h-3.5 shrink-0 text-emerald-400" aria-hidden />
          <span className="break-words text-center">{copy.sectionPartnershipTitle}</span>
        </div>
        <h2 className="text-2xl sm:text-4xl font-black text-white tracking-tight break-words px-1">
          {copy.sectionPartnershipTitle}
        </h2>
        <p className="text-white/50 mt-3 max-w-3xl mx-auto font-light leading-relaxed break-words">
          {copy.sectionPartnershipLead}
        </p>
        <div className="w-20 h-1 bg-gradient-to-r from-emerald-500 to-cyan-500 mx-auto rounded-full mt-6" />
      </div>

      <div className="grid gap-5 sm:grid-cols-2">
        {copy.partnershipModels.map((model, i) => {
          const Icon = modelIcons[i] || Sparkles;
          return (
            <article
              key={model.title}
              className="group relative flex flex-col rounded-[1.5rem] border border-white/[0.1] bg-slate-950/35 backdrop-blur-md p-6 sm:p-7 transition-all duration-300 hover:border-emerald-500/25 hover:shadow-[0_20px_60px_-30px_rgba(52,211,153,0.15)]"
            >
              <div className="w-11 h-11 rounded-xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
                <Icon className="w-5 h-5 text-emerald-400" aria-hidden />
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white mb-2">{model.title}</h3>
              <p className="text-sm text-white/50 font-light leading-relaxed flex-1">{model.desc}</p>
            </article>
          );
        })}
      </div>

      <p className="mt-8 text-sm sm:text-base text-emerald-100/75 text-center max-w-3xl mx-auto leading-relaxed font-light px-4 rounded-xl border border-emerald-500/20 bg-emerald-500/[0.06] py-4 sm:py-5">
        {copy.partnershipDisclaimer}
      </p>

      <div className="mt-8 flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center justify-center gap-3">
        <Button asChild size="lg" className="rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 text-slate-950 font-semibold shadow-lg shadow-amber-900/25 h-12 px-6">
          <a href={quoteUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2">
            {copy.btnPartnershipProposal}
            <ArrowRight className="w-4 h-4" aria-hidden />
          </a>
        </Button>
        <Button
          type="button"
          size="lg"
          variant="outline"
          className="rounded-xl border-emerald-500/35 bg-emerald-500/10 text-emerald-100 hover:bg-emerald-500/15 h-12 px-6"
          onClick={onWhatsapp}
        >
          <MessageCircle className="w-4 h-4 mr-2 shrink-0" aria-hidden />
          {copy.btnImplementation}
        </Button>
        <Button asChild size="lg" variant="outline" className="rounded-xl border-white/20 bg-white/[0.04] text-white hover:bg-white/10 h-12 px-6">
          <a href={quoteUrl} target="_blank" rel="noopener noreferrer">
            {copy.btnStrategicMeeting}
          </a>
        </Button>
      </div>
    </section>
  );
}
